export enum TicketType {
  Bug = "Bug",
  Improvement = "Verbesserung",
  Suggestion = "Vorschlag",
}

export enum TicketStatus {
  Created = "Erstellt",
  Open = "Offen",
  InProgress = "In Bearbeitung",
  Closed = "Geschlossen",
  Rejected = "Abgelehnt",
}

export enum TicketTypeEnum {
    // do not edit keys -> they are translated
    ticketTypeBug = 0,
    ticketTypeImprovement = 1,
    ticketTypeFeatureRequest = 2,
}